import moment from 'moment-jalaali';

/*eslint no-extend-native: ["error", { "exceptions": ["Number"] }]*/
Number.prototype.commaSeparated = function (decimal) {
	return decimal >= 0 ? (+(this.toFixed(decimal))).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : this.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

Number.prototype.roundPrice = function () {
	return Math.round(this) - 0.01;
}

Number.prototype.toLetter = function () {
	const positions = ['', 'هزار', 'میلیون', 'میلیارد', 'تریلیون', 'تریلیارد'];
	let s = "";
	// console.log(Num2persian(decimal));
	let number = this;
	for (let i = 0; number > 0; i++) {
		s = number % 1000 > 0 ? (number % 1000 + " " + (i ? positions[i] : '') + (s ? " و " : "") + s) : s;
		number = Math.floor(number / 1000);
	}
	return s;
};

class UtilityAPI {

	static chunks(arr, size) {
		if (!Array.isArray(arr)) {
			throw new TypeError('Input should be Array');
		}

		if (typeof size !== 'number') {
			throw new TypeError('Size should be a Number');
		}

		var result = [];
		for (var i = 0; i < arr.length; i += size) {
			result.push(arr.slice(i, size + i));
		}

		return result;
	}

	static toType(obj) {
		return ({}).toString.call(obj).match(/\s([a-zA-Z]+)/)[1].toLowerCase()
	}

	static getImageURL(id) {
		const s = 'http://placehold.it/' + (Math.floor(Math.random() * 100) + 100) + "x" + (Math.floor(Math.random() * 100) + 100);
		//return "/images/bread.jpg";
		return s;
	}

	static getMessage(msg) {
		return '[' + new Date().getHours() + ':' + new Date().getMinutes() + ':' + new Date().getSeconds() + '] ' + msg;
	}

	static randomDate(start, end) {
		return new Date(start.getTime() + Math.random() * (end.getTime() - start.getTime()));
	}

	static addToDate(date, duration) {
		if (!duration) {
			return date;
		}
		if (duration.months) date.setDate(date.getDate() + duration.months * 30);
		if (duration.weeks) date.setDate(date.getDate() + duration.days * 7);
		if (duration.days) date.setDate(date.getDate() + duration.days);
		if (duration.hours) date.setTime(date.getTime() + (duration.hours * 60 * 60 * 1000));
		if (duration.minutes) date.setTime(date.getTime() + duration.minutes * 60000);
		if (duration.seconds) date.setSeconds(date.getSeconds() + duration.seconds);
		return date;
	}

	//-----------------------------------------------------------------
	static emptyDuration(duration) {
		return !(duration.months || duration.weeks || duration.days || duration.hours || duration.minutes) ? true : false;
	}

	//-----------------------------------------------------------------
	static groupBy(xs, key) {
		return xs.reduce(function (rv, x) {
			(rv[x[key]] = rv[x[key]] || []).push(x);
			return rv;
		}, {});
	}

	//-----------------------------------------------------------------
	static shuffleArray(array) {
		for (let i = array.length - 1; i > 0; i--) {
			const j = Math.floor(Math.random() * (i + 1));
			[array[i], array[j]] = [array[j], array[i]]; // eslint-disable-line no-param-reassign
		}
	}

	//------------------------------------------------------------------------------*/
	static uniqueItems(value, index, self) {
		return self.indexOf(value) === index;
	}

	//------------------------------------------------------------------------------*/
	static getDaysArray(start, end, count) {
		start = new Date(start);
		end = new Date(end);
		for (var arr = [], dt = start; dt <= end; dt.setDate(dt.getDate() + count)) {
			arr.push(dt.getTime());
		}
		return arr;
	}

	//------------------------------------------------------------------------------*/
	static getTextWidth(text, font) {
		var canvas = UtilityAPI.getTextWidth.canvas || (UtilityAPI.getTextWidth.canvas = document.createElement("canvas"));
		var context = canvas.getContext("2d");
		context.font = font;
		var metrics = context.measureText(text);
		return metrics.width;
	}

	//------------------------------------------------------------------------------*/	
	static sameDay(d1, d2) {
		d1 = d1 ? new Date(d1) : new Date();
		d2 = d2 ? new Date(d2) : new Date();
		return d1.getFullYear() === d2.getFullYear() && d1.getMonth() === d2.getMonth() && d1.getDate() === d2.getDate();
	}
	//------------------------------------------------------------------------------*/	
	static validateEmail(email) {
		var re = /^(([^<>()\]\\.,;:\s@"]+(\.[^<>()\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		return re.test(String(email).toLowerCase());
	}

	//------------------------------------------------------------------------------*/	
	static hasPersianChar(s) {
		return /^(?=.*[آ-ی]).*$/.test(s);
	}

	//------------------------------------------------------------------------------*/	
	static validateMobileNo(mobile) {
		return /^(09)([0-9]{9})$/.test(mobile);
	}

	//------------------------------------------------------------------------------*/	
	static validateInternationalMobileNo(mobile) {
		return /^[-+]?[0-9]{1,15}$/.test(mobile);
	}

	//------------------------------------------------------------------------------*/	
	static convertPersianNo(no) {
		const nonEnglishNumbers = [
			['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'],
			['۰', '۱', '۲', '۳', '٤', '۵', '٦', '۷', '۸', '۹'],
			['٠', '١', '٢', '٣', '٤', '٥', '٦', '٧', '٨', '٩'],
			['٠', '١', '٢', '٣', '٤', '٥', '٦', '٧', '٨', '٩'],
		];
		nonEnglishNumbers.forEach(numbers =>
			numbers.forEach((pn, idx) => {
				let res = new RegExp(pn, 'g');
				no = no?.replace && no?.replace(res, '' + idx);
			})
		);
		return no;
	}

	//------------------------------------------------------------------------------
	static getLocalTime(offset) {
		const d = new Date();
		var utc = d.getTime() + (d.getTimezoneOffset() * 60000);
		return new Date(utc + (3600000 * offset));
	}

	static toLetter = function (number) {
		const positions = ['', 'هزار', 'میلیون', 'میلیارد', 'بیلیون', 'بیلیارد', 'تریلیون'];
		let s = "";
		// console.log(Num2persian(number));

		for (let i = 0; number > 0; i++) {
			s = number % 1000 + " " + (i ? positions[i] : '') + (s ? " و " : "") + s;
			number = Math.floor(number / 1000);
		}
		return s;
	}

	//------------------------------------------------------------------------------
	static difDay(n) {
		let toDayStart = new Date();
		// return n >= 0 ? moment().add(n, 'days').valueOf() : moment().subtract(-n, 'days').valueOf();
		toDayStart.setHours(0, 0, 0, 0);
		return toDayStart.getTime() + n * 24 * 60 * 60 * 1000;
	}

	//------------------------------------------------------------------------------
	static toggle(list, value) {
		return !list ? [value] : (list.includes(value) ? list.filter(gt => gt !== value) : list.concat([value]));
	}

	//------------------------------------------------------------------------------
	static classBuilder(classes) {
		return Object.keys(classes).reduce((t, k) => classes[k] ? t.concat(k.split(" ").filter(c => !t.find(tc => tc === c))) : t, []).join(" ");
	}

	//------------------------------------------------------------------------------
	static getValue(classes) {
		let k = Object.keys(classes).find(k => classes[k]);
		// return k ? classes[k] : undefined;
		return k;
	}
	//------------------------------------------------------------------------------
	static getListValue(list) {
		let k = list?.findIndex((c, idx) => idx % 2 === 0 && c ? true : false);
		return k >= 0 ? list[k + 1] : undefined;
	}

	//------------------------------------------------------------------------------
	static getFirstValue(list) {
		return list?.find(c => c.cond)?.value;
	}

	//--------------------------------------------------------------
	static validateEntity(props) {
		const { conditions } = props;
		const entity = props[Object.keys(props)[0]];
		let title = Object.keys(props)[0];

		if (!entity) {
			return `${title || 'Entity'} is Empty`;
		}

		const errorFields = Object.keys(conditions).filter(field => !conditions[field]({ ...entity, ...props }));
		if (errorFields.length) {
			return `${title || 'Entity'} has empty fields [${errorFields.join(", ")}]`;
		}
	}

	//-----------------------------------------------------------------
	static formatAudit = ({ prefix, fields, i18n, arrayFields, currencyFields, dateFields, areaFields, singleFields, mapFields, customMsg }) => {
		const getValue = (field, value, data, dest) => {
			if (value && arrayFields?.includes(field)) {
				return value.map(v => i18n(v)).join('، ');
			}
			else if (value && currencyFields?.includes(field)) {
				return value.commaSeparated ? value.commaSeparated() : value;
			}
			else if (value && dateFields?.includes(field)) {
				return (new Date(value).getTime() > 0 ? moment(value).format('HH:mm jYYYY/jMM/jDD') : value) || '-';
			}
			else if (value && areaFields?.includes(field)) {
				return value?.name || value;
			}
			else if (mapFields && Object.keys(mapFields).includes(field)) {
				const v = mapFields[field](value, data, dest);
				return typeof v === 'string' ? i18n(v) : v;
			}
			return (value && typeof value === 'string' ? i18n(value) : value) || '-';
		}
		const list = fields?.map && fields?.map((field) => {
			const { name, from, to } = field;
			if (singleFields && Object.keys(singleFields).includes(name)) {
				return i18n(singleFields[name]) || '-';
			}
			if (customMsg && customMsg[name]) {
				// console.log(fields);
				return customMsg[name](getValue(name, from, field), getValue(name, to, field), field);
			}

			// console.log(i18n((prefix ? prefix + '_' : '') + name), i18n(name));

			let _name = (prefix ? prefix + '_' : '') + name;
			return `${i18n(_name) === _name ? i18n(name) : i18n(_name)} از ${getValue(name, from, field, 'from')} به ${getValue(name, to, field, 'to')}`
		});
		return list?.some(c => typeof c !== 'string') ? list[0] : list?.filter(UtilityAPI.uniqueItems).join("، ") || '-';
	}

	//------------------------------------------------------------------------------
	static errorBuilder(errors) {
		return Object.keys(errors).find(k => errors[k]);
	}

	//------------------------------------------------------------------------------
	static isMobile(userAgent) {
		return ['android', 'ios', 'ipados'].includes(userAgent?.os?.name?.toLowerCase());
	}

	//-----------------------------------------------------------------------------------
	static getRandomCode(length) {
		const min = 5;
		const max = 10;

		const randomNumber = Math.floor(Math.random() * (max - min + 1)) + min;
		length = length || randomNumber;

		var generated = '';
		const possible = "abcdefghijklmnopqrstuvwxyz0123456789";
		for (var i = 0; i < length;) {
			let ch = possible.charAt(Math.floor(Math.random() * possible.length));
			if (generated.indexOf(ch) >= 0) {
				continue;
			}
			generated += ch;
			i++;
		}

		return generated.toUpperCase();
	}
}

export default UtilityAPI;
